import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

const ShippingAddress = ({ contact: { firstName, lastName, address1, address2, city, state, country } }) => {
    if (!firstName || !lastName || !city || !address1 || !country) {
        return null;
    }

    return (
        <div className={ styles.shippingAddress }>
            <div className={ styles.label }>Your mailing address</div>
            <div className={ styles.text }>
                <div className={ styles.name }>{ firstName } { lastName }</div>
                <div className={ styles.addressLine1 }>{ address1 }</div>
                <div className={ styles.addressLine2 }>{ address2 }</div>
                <div className={ styles.cityAndState }>{ city }, { state }</div>
                <div className={ styles.country }>{ country }</div>
            </div>
        </div>
    );
};

ShippingAddress.propTypes = {
    contact: PropTypes.arrayOf([PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        address1: PropTypes.string.isRequired,
        address2: PropTypes.string,
        city: PropTypes.string.isRequired,
        state: PropTypes.string,
        country: PropTypes.string.isRequired
    })])
};

export default ShippingAddress;
